import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InstanceService } from '../../modules/instance/services/instance.service';

@Injectable()
export class StateInterceptor implements HttpInterceptor {
    constructor(private readonly instanceService: InstanceService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let newRequest = request.clone();

        if (this.instanceService.hasSelectedInstance) {
            const params = request.params || null;
            const existedStateEnv = params.get('state_env') || request.url.indexOf('state_env') > 0;
            if (!existedStateEnv) {
                newRequest = request.clone({
                    setParams: {
                        state_env: this.instanceService.selectedInstance.State
                    }
                });
            }
        }

        return next.handle(newRequest);
    }
}
